module.exports = __webpack_public_path__ + "static/img/icon-3.14406187.png";